// Angular
import { Injectable } from '@angular/core';
// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
// RxJS
import { map, mergeMap } from 'rxjs/operators';

// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  InvoiceCheckReportActionToggleLoading,
  InvoiceCheckReportActionTypes,
  InvoiceCheckReportPageLoaded,
  InvoiceCheckReportPageRequested,
  InvoiceCheckReportPageToggleLoading,
} from '../_actions/invoice_check_report.actions';
// Services
import { InvoiceCheckReportService } from '../_services/invoice_check_report.service';

@Injectable()
export class InvoiceCheckReportEffects {
  showPageLoadingDistpatcher = new InvoiceCheckReportPageToggleLoading({
    isLoading: true,
  });
  hidePageLoadingDistpatcher = new InvoiceCheckReportPageToggleLoading({
    isLoading: false,
  });

  showActionLoadingDistpatcher = new InvoiceCheckReportActionToggleLoading({
    isLoading: true,
  });
  hideActionLoadingDistpatcher = new InvoiceCheckReportActionToggleLoading({
    isLoading: false,
  });

  loadInvoiceCheckReportPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<InvoiceCheckReportPageRequested>(
        InvoiceCheckReportActionTypes.InvoiceCheckReportPageRequested
      ),
      mergeMap(({ payload }) => {
        this.store.dispatch(this.showPageLoadingDistpatcher);
        const requestToServer = this.icrs.findInvoiceCheckReports(payload.page);
        const lastQuery = of(payload.page);
        return forkJoin(requestToServer, lastQuery);
      }),
      map(response => {
        const result: QueryResultsModel = response[0];
        const lastQuery: QueryParamsModel = response[1];
        return new InvoiceCheckReportPageLoaded({
          InvoiceCheckReports: result.items,
          totalCount: result.totalCount,
          page: lastQuery,
        });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private icrs: InvoiceCheckReportService,
    private store: Store<AppState>
  ) {}
}
